"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowEndHotspot = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importDefault(require("react"));
var model_1 = require("../../../model");
var coordinates_1 = require("../../../_staging/layout/coordinates");
var Hotspot_1 = require("./Hotspot");
var WidgetDropZoneColumn_1 = require("./WidgetDropZoneColumn");
exports.RowEndHotspot = function (props) {
    var item = props.item, screen = props.screen;
    var isInEditMode = model_1.useDashboardSelector(model_1.selectIsInEditMode);
    var _a = coordinates_1.getLayoutCoordinates(item), sectionIndex = _a.sectionIndex, itemIndex = _a.itemIndex;
    var isLastInSection = item.isLast();
    var showEndingHotspot = isLastInSection && isInEditMode;
    if (!showEndingHotspot) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(WidgetDropZoneColumn_1.WidgetDropZoneColumn, { screen: screen, sectionIndex: sectionIndex, itemIndex: itemIndex + 1, isLastInSection: true }),
        react_1.default.createElement("div", { className: classnames_1.default("gd-fluidlayout-column", "gd-fluidlayout-column-row-end-hotspot", "s-fluid-layout-column", "s-fluid-layout-screen-" + screen) },
            react_1.default.createElement(Hotspot_1.Hotspot, { dropZoneType: "next", isEndingHotspot: true, itemIndex: itemIndex, sectionIndex: sectionIndex, isLastInSection: item.isLast() }))));
};
//# sourceMappingURL=RowEndHotspot.js.map